import { acne, acneBeluga } from './Initial/flow';

const acneFlows = {
  acneBeluga,
  acne
};

export default acneFlows;
